// Libraries
import React, { useEffect, useMemo, useState } from 'react';
import { connect } from 'react-redux';
import { IntlProvider } from 'react-intl';
import * as i18n from '../../../config/i18n';
// Our stuff
// @ts-ignore
import * as Components from '../components';
import { ThemeProvider } from "styled-components";
import { theme } from "DesignSpecs/data/theme";
import ErrorBoundry from '../components/ErrorBoundry';
import './App.css';
import * as sharedActions from '../shared/actions/App';
import * as CookieHelper from '../shared/utils/CookieHelper';
import queryString from 'query-string'
import { jwtDecode } from 'jwt-decode';
import TLSWarning from 'components/TLSWarning';
import IEWarningBanner from 'components/IEWarningBanner';
import { useLocation } from 'react-router-dom';
//import OnlineStatus from 'components/OnlineStatus';

import { AppStateProvider } from "../shared/AppState/app-state";
import appReducer, { initialState } from "../shared/AppState/appReducer";
import ApolloProviderWrapper from "../../../config/ApolloProviderWrapper";

import { initGA } from 'services/GoogleAnalytics';

const App = (props) => {
  const location = useLocation();
  const [country, setCountry] = useState(() => {
    const params = queryString.parse(location.search);
    return params?.country || '';
  });

  const selectedLocale = props.languageLocale;
  const isARIUser = useMemo(() => {
    try {
      return props.token && jwtDecode(props.token).sub === 'ARIUSER';
    } catch {
      return false;
    }
  }, [props.token]);

  const isValidPathToDisplayTLSWarning = useMemo(() => {
    const url = window.location.href.toLowerCase();
    return !(url.includes('/login') || url.includes('/tlswarning/learnmore'));
  }, []);

  useEffect(() => {
    initGA();

    if (country !== '') {
      let languageLocale = '';

      if (country === 'USA' || country === 'CAN' || country === 'MEX') {
        props.dispatch(sharedActions.setSelectedCountry(country));
      }

      if (country === 'MEX') {
        languageLocale = 'es-MX';
      }

      if (languageLocale) {
        props.dispatch(sharedActions.selectLocale(languageLocale));
        CookieHelper.createCookie('vms_language_preference', JSON.stringify({ languageLocaleCookie: languageLocale }));
      }
    }
  }, [country, props.dispatch]);

  const timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;

  return (
    <IntlProvider key={selectedLocale} locale={selectedLocale} messages={i18n[selectedLocale.substring(0, 2)]} timeZone={timeZone}>
      <ThemeProvider theme={theme}>
        <ErrorBoundry>
          <AppStateProvider reducer={appReducer} initialState={{ ...initialState, personaToken: props.personaToken }}>
            <div>
              <Components.Error />
              {isValidPathToDisplayTLSWarning && <TLSWarning />}
              <IEWarningBanner />
              {isARIUser && !window.location.href.includes('/ariuser') && <Components.SearchVendor />}
              {/* <OnlineStatus /> */}

              <Components.Header>
                {props.header}
              </Components.Header>

              <Components.Content sideBar={props.sideBar} body={props.body} location={location} />

              <Components.Footer selectedCountry={props.selectedCountry}>
                {props.footer}
              </Components.Footer>
            </div>
          </AppStateProvider>
        </ErrorBoundry>
      </ThemeProvider>
    </IntlProvider>
  );
};

// Which props do we want to inject, given the global state?
function select(state) {
  return {
    errorMessage: state.appState.getIn(['uiData', 'shared', 'errorMessage']),
    token: state.appState.getIn(['serverData', 'shared', 'token']),
    personaToken: state.appState.getIn(['serverData', 'shared', 'personaToken']),
    languageLocale: state.appState.getIn(['uiData', 'shared', 'selectedLocale']) || "en-US",
        selectedCountry: state.appState.getIn(['uiData', 'shared', 'selectedCountry'])
  };
}

export default connect(select)(App);
